import { Currency } from '@commercetools/frontend-sdk/lib/types/Currency';

interface LocalizationMapping {
  locale: string;
  currency: Currency;
  currencyCode: string;
  countryName: string;
  countryCode: string;
}

const localizationMapper = {
  'en_AU@AUD': {
    locale: 'en_AU@AUD',
    currency: 'AUD',
    currencyCode: '$',
    countryCode: 'AU',
    countryName: 'Australia',
  },
  'en_AU@NZD': {
    locale: 'en_AU@NZD',
    currency: 'NZD',
    currencyCode: '$',
    countryCode: 'NZ',
    countryName: 'New Zealand',
  },
} as Record<string, LocalizationMapping>;

const locales = Object.keys(localizationMapper);
const defaultLocale = locales[0];

export const i18nConfig = { locales, defaultLocale };

export const getLocalizationInfo = (locale: string) => {
  if (!(locale in localizationMapper)) {
    console.warn(
      `Invalid locale ${locale} provided. Possible values are ${Object.keys(localizationMapper).join(', ')}`,
    );

    return localizationMapper[defaultLocale];
  }

  return localizationMapper[locale as keyof typeof localizationMapper];
};
